module.exports = __webpack_public_path__ + "static/media/peacock-trans.54487b1a.png";